import { ErrorMessage, Field } from "formik";
import React from "react";
// import '../css/LoginPage.css'

const InputField = ({ label, name, type, placeholder }) => {
  return (
    <div className="input-field">
      <label htmlFor="{name}">{label}</label>
      <Field
        id={name}
        name={name}
        type={type}
        placeholder={placeholder}
        className="form-input"
      />

      <ErrorMessage name={name} component="span" className="error-text" />
    </div>
  );
};

export default InputField;
